import React from 'react';
import logoImg from '../assets/ploys-logo.png';

const Logo = ({ className = '', size = 'md' }) => {
  const sizes = {
    sm: 'h-10',
    md: 'h-14',
    lg: 'h-20 sm:h-24'
  };
  return (
    <img
      src={logoImg}
      alt="Ploy's Thai Food"
      className={`${sizes[size]} w-auto object-contain select-none ${className}`}
      data-testid="ploys-logo"
      draggable="false"
    />
  );
};

export default Logo;
